import { queryOptions } from '@tanstack/react-query';
import { privateClient } from '../axiosClients/axiosClients';

export async function getOverview(params) {
  const response = await privateClient.get(`/overview?pecrId=${params.pecrId}`);
  return response.data;
}

export function createGetOverviewOptions(params, options) {
  return queryOptions({
    ...options,
    queryKey: ['overview', params],
    queryFn: () => getOverview(params),
    retry: 1,
    refetchOnWindowFocus: false,
  });
}

export async function getParticularOverview(params) {
  const response = await privateClient.get(
    `getOverviewById?pecrId=${params.pecrId}`
  );
  return response.data;
}

export function createGetParticularOverviewOptions(params, options) {
  return queryOptions({
    ...options,
    queryKey: ['particular-overview', params],
    queryFn: () => getParticularOverview(params),
    retry: 1,
    refetchOnWindowFocus: false,
  });
}

export async function getFiles(params) {
  const response = await privateClient.get(
    `getFiles?mainFolder=${params.mainFolder}&subFolder=${params.subFolder}`
  );
  const files = response.data.filter(file => {
    return file.includes('.');
  });
  return files;
}
export function createGetFilesOptions(params, options) {
  return queryOptions({
    ...options,
    queryKey: ['files', params],
    queryFn: () => getFiles(params),
    retry: 1,
    refetchOnWindowFocus: false,
  });
}

export async function getProductFamilyList() {
  const response = await privateClient.get('ProductFamilyList');
  console.log('response', response);
  return response.data;
}

export function createGetProductFamilyListOptions(options) {
  return queryOptions({
    ...options,
    queryKey: ['product-family-list'],
    queryFn: () => getProductFamilyList(),
    retry: 1,
    refetchOnWindowFocus: false,
  });
}

export async function getSiteName(params) {
  const response = await privateClient.get(
    `SiteName?email=${params.userEmail}`
  );
  return response.data;
}

export function createGetSiteNameOptions(params, options) {
  return queryOptions({
    ...options,
    queryKey: ['site-name', params],
    queryFn: () => getSiteName(params),
    retry: 1,
    refetchOnWindowFocus: false,
  });
}

export async function getLSC(params) {
  const response = await privateClient.get(
    `getLSC?pecrId=${params.pecrId}&siteId=${params.ID}`
  );
  return response.data;
}

export function createGetLSCOptions(params, options) {
  return queryOptions({
    ...options,
    queryKey: ['lsc', params],
    queryFn: () => getLSC(params),
    retry: 1,
    refetchOnWindowFocus: false,
  });
}

async function getReviewSteps(params) {
  const response = await privateClient.get(
    '/reviewSteps?pecrId=' + params.pecrId
  );
  return response.data;
}

export function createGetReviewStepsOptions(params, options) {
  return queryOptions({
    ...options,
    queryKey: ['review-steps', params],
    queryFn: () => getReviewSteps(params),
    retry: 1,
    refetchOnWindowFocus: false,
  });
}

export async function getEstimationSteps(params) {
  const response = await privateClient.get(
    '/estimationSteps?pecrId=' + params.pecrId
  );
  return response.data;
}

export function createGetEsimtationStepsOptions(params, options) {
  return queryOptions({
    ...options,
    queryKey: ['estimation-steps', params],
    queryFn: () => getEstimationSteps(params),
    retry: 1,
    refetchOnWindowFocus: false,
  });
}

async function getExecutionSteps(params) {
  const response = await privateClient.get(
    '/executionSteps?pecrId=' + params.pecrId
  );
  return response.data;
}

export function createGetExecutionStepsOptions(params, options) {
  return queryOptions({
    ...options,
    queryKey: ['execution-steps', params],
    queryFn: () => getExecutionSteps(params),
    retry: 1,
    refetchOnWindowFocus: false,
  });
}

async function getOverviewSteps(params) {
  const response = await privateClient.get(
    '/overviewSteps?pecrId=' + params.pecrId
  );
  return response.data;
}

export function createGetOverviewStepsOptions(params, options) {
  return queryOptions({
    ...options,
    queryKey: ['overview-steps', params],
    queryFn: () => getOverviewSteps(params),
    retry: 1,
    refetchOnWindowFocus: false,
  });
}

async function getValueAdjustment(params) {
  const response = await privateClient.get(
    '/FetchPECRAdjustment?pecrId=' + params.pecrId + '&siteId=' + params.siteId
  );
  return response.data;
}

export function createGetValueAdjustmentOptions(params, options) {
  return queryOptions({
    ...options,
    queryKey: ['value-adjustment', params],
    queryFn: () => getValueAdjustment(params),
    retry: 1,
    refetchOnWindowFocus: false,
  });
}

export async function saveValueAdjustment(params) {
  const response = await privateClient.put('/UpdatePECRAdjustment', {
    ...params,
  });
  return response.data;
}

export async function postResourceModification(params) {
  const response = await privateClient.post(
    '/ResourceModificationBasedonSite',
    {
      ...params,
    }
  );
  return response.data;
}

export async function cancelPecr(params) {
  const response = await privateClient.put('/CancelPECRFromSummary', {
    ...params,
  });
  return response.data;
}
